import React from 'react'

const StepsContext = React.createContext({})

export default function Steps ({ children, steps: _s }) {
  const [steps, setSteps] = React.useState(_s)
  const [currentStep, setCurrentStep] = React.useState(0)
  const [errors, setErrors] = React.useState(null)

  return (
    <StepsContext.Provider value={{
      currentStep,
      setCurrentStep,
      steps,
      setSteps,
      errors,
      setErrors
    }}>
      {children}
    </StepsContext.Provider>
  )
}

export { StepsContext }
